const chelsea = [
  {
    id: 1,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2025", "2025 chelsea", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/25-26-01/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/25-26-01/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/25-26-01/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/25-26-01/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2025", "2025 chelsea", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/25-26-02/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/25-26-02/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/25-26-02/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/25-26-02/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 25/26 - Uniforme 3",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2025", "2025 chelsea", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/25-26-03/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/25-26-03/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/25-26-03/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/25-26-03/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2024", "2024 chelsea", "2024"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/24-25-01/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/24-25-01/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/24-25-01/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/24-25-01/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2024", "2024 chelsea", "2024"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/24-25-02/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/24-25-02/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/24-25-02/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/24-25-02/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 24/25 - Uniforme 3",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2024", "2024 chelsea", "2024"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/24-25-03/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/24-25-03/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/24-25-03/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/24-25-03/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/24-25-03/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 22/23 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2022", "2022 chelsea", "2022"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/22-23-00-es/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/22-23-00-es/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/22-23-00-es/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/22-23-00-es/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/22-23-00-es/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 21/22 - Uniforme 1",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2021", "2021 chelsea", "2021"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/21-22-01/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/21-22-01/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/21-22-01/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/21-22-01/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/21-22-01/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 21/22 - Uniforme 2",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2021", "2021 chelsea", "2021"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/21-22-02/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/21-22-02/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/21-22-02/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/21-22-02/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 21/22 - Uniforme 3",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2021", "2021 chelsea", "2021"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/21-22-03/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/21-22-03/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/21-22-03/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/21-22-03/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/21-22-03/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 20/21 - Uniforme 3",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2020", "2020 chelsea", "2020"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/20-21-03/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/20-21-03/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/20-21-03/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/20-21-03/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/20-21-03/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 19/20 - Uniforme 1",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2019", "2019 chelsea", "2019"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/19-20-01/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/19-20-01/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/19-20-01/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/19-20-01/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/19-20-01/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 14/15 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2014", "2014 chelsea", "2014"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/14-15-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/14-15-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/14-15-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/14-15-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/14-15-01-rt/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 12/13 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2012", "2012 chelsea", "2012"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/12-13-02-rt/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/12-13-02-rt/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/12-13-02-rt/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/12-13-02-rt/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/12-13-02-rt/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 12/13 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2012", "2012 chelsea", "2012"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/12-13-03-rt/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/12-13-03-rt/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/12-13-03-rt/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/12-13-03-rt/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/12-13-03-rt/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 09/10 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2009", "2009 chelsea", "2009"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/09-10-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/09-10-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/09-10-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/09-10-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/09-10-01-rt/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 06/07 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2006", "2006 chelsea", "2006"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/06-07-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/06-07-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/06-07-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/06-07-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/06-07-01-rt/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 04/05 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 2004", "2004 chelsea", "2004"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/04-05-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/04-05-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/04-05-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/04-05-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/04-05-01-rt/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 98/99 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 1998", "1998 chelsea", "1998"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/98-99-02-rt/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/98-99-02-rt/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/98-99-02-rt/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/98-99-02-rt/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/98-99-02-rt/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 97/98 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 1997", "1997 chelsea", "1997"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/97-98-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/97-98-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/97-98-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/97-98-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/97-98-01-rt/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 94/95 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 1994", "1994 chelsea", "1994"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/94-95-02-rt/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/94-95-02-rt/uni1.jpg",
      "/images/inglaterra/premier-league/chelsea/94-95-02-rt/uni2.jpg",
      "/images/inglaterra/premier-league/chelsea/94-95-02-rt/uni3.jpg",
      "/images/inglaterra/premier-league/chelsea/94-95-02-rt/uni4.jpg",
    ],
  },
  {
    id: 23,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 90/91 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 1990", "1990 chelsea", "1990"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/90-91-02-rt/uni0.jpeg",
      "/images/inglaterra/premier-league/chelsea/90-91-02-rt/uni1.jpeg",
      "/images/inglaterra/premier-league/chelsea/90-91-02-rt/uni2.jpeg",
      "/images/inglaterra/premier-league/chelsea/90-91-02-rt/uni3.jpeg",
      "/images/inglaterra/premier-league/chelsea/90-91-02-rt/uni4.jpeg",
    ],
  },
  {
    id: 24,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea 90/91 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: ["chelsea", "the blues", "chelsea 1990", "1990 chelsea", "1990"],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/90-91-03-rt/uni0.jpeg",
      "/images/inglaterra/premier-league/chelsea/90-91-03-rt/uni1.jpeg",
      "/images/inglaterra/premier-league/chelsea/90-91-03-rt/uni2.jpeg",
      "/images/inglaterra/premier-league/chelsea/90-91-03-rt/uni3.jpeg",
      "/images/inglaterra/premier-league/chelsea/90-91-03-rt/uni4.jpeg",
    ],
  },
  {
    id: 25,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea - Jaqueta (Azul)",
    tipo: "masculino",
    aliases: [
      "chelsea",
      "the blues",
      "chelsea jaqueta",
      "jaqueta chelsea",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/ja/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/ja/uni1.jpg",
    ],
  },
  {
    id: 26,
    pais: "inglaterra",
    liga: "premier-league",
    time: "chelsea",
    nome: "Chelsea - Jaqueta (Preta)",
    tipo: "masculino",
    aliases: [
      "chelsea",
      "the blues",
      "chelsea jaqueta",
      "jaqueta chelsea",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/chelsea/jp/uni0.jpg",
      "/images/inglaterra/premier-league/chelsea/jp/uni1.jpg",
    ],
  },
];

export default chelsea;
